import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MwPipesModule } from './pipes/pipes.module';
import { MwProgressBarModule } from './components';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MwPipesModule,
    MwProgressBarModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MwPipesModule,
    MwProgressBarModule,
  ],
})
export class MwSharedModule {}
